import SectionHeading from "@/components/base/SectionHeading";

const quotes = [
  {
    text: "最有用的是时间线，一件事从头跟到尾都在同一个页面里，不用再去翻好几条零碎的更新。",
    name: "周先生",
    role: "每天通勤路上看快讯",
  },
  {
    text: "突发消息里会把还在核实的地方标出来，这一点挺难得的，至少知道哪些话先别急着信。",
    name: "李女士",
    role: "关注本地动态的普通读者",
  },
  {
    text: "早上收到速递邮件，一分钟扫完当天重点，比我自己一条条刷效率高很多。",
    name: "陈同学",
    role: "订阅今日速递的用户",
  },
];

export default function Testimonials() {
  return (
    <section aria-label="读者反馈" className="mx-auto max-w-[1400px] px-4 md:px-6">
      <SectionHeading
        title="读者怎么说"
        subtitle="以下是读者反馈渠道中较有代表性的声音"
        icon="ri-chat-quote-line"
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {quotes.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
          >
            <i className="ri-double-quotes-l text-2xl text-primary-400" />
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-4 border-t border-background-200 pt-4">
              <span className="block font-serif-cn text-sm font-semibold text-foreground-950">
                {item.name}
              </span>
              <span className="block text-xs text-foreground-500">{item.role}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}